<script setup lang="ts">
import { defineProps, computed } from "vue";

type Props = {
  progress: number;
  warning?: boolean;
  color?: string;
};

const props = defineProps<Props>();

const warning = computed(() => props.warning);
</script>

<template>
  <div class="w-full">
    <div v-if="warning">
      <div class="bg-progress-bg-warning h-[5px] w-full"></div>
    </div>
    <div
      v-else
      class="h-[5px]"
      :class="`${progress === 100 ? 'bg-[#4D48A6]' : 'bg-progress-background'}`"
      :style="{ width: progress + '%' }"
    ></div>
  </div>
</template>
